import React from 'react';
import SVG from "react-inlinesvg";
import { Modal } from "react-bootstrap";
import { NavLink } from 'react-router-dom';
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers";
import ErrorMessage from './ErrorMessage';


const DeleteSavedCard = ({show, action: {action, error, actedOn, data}, onHide}) => {

    return <Modal
            show={show}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
          >
            <Modal.Header >
              <Modal.Title id="contained-modal-title-vcenter">
                <span className={`svg-icon svg-icon-lg svg-icon-danger mr-3`}>
                    <SVG
                        title=""
                        src={toAbsoluteUrl("/media/svg/icons/Shopping/Credit-card.svg")}
                    />
                </span> {action}
              </Modal.Title>
              <button type="button" className="close" onClick={onHide}>
                  <span aria-hidden="true" className="d-block">×</span>
                  <span className="sr-only">Close</span>
               </button>
            </Modal.Header>
            <Modal.Body>
                <ErrorMessage {...{error}} />
                <div className="px-md-5">
                    <div className="row">
                        <div className="col-md-5 h6">
                            User
                        </div>
                        <div className="col-md h6 text-muted">
                            <NavLink to={`/users/view/${data?.userId}`} target="_blank" >
                                {`${data.meta?.firstName ?? ""} ${data.meta?.lastName ?? ""}`}
                            </NavLink>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-5 h6">
                            Email
                        </div>
                        <div className="col-md h6 text-muted">
                            {data.meta?.email}
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-5 h6">
                            Card Type
                        </div>
                        <div className="col-md h6 text-muted">
                            {data.meta?.card?.cardType}
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-5 h6">
                            Bin
                        </div>
                        <div className="col-md h6 text-muted">
                            {data.meta?.card?.bin}
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-5 h6">
                            Last4
                        </div>
                        <div className="col-md h6 text-muted">
                            {data.meta?.card?.last4}
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-5 h6">
                            Expire
                        </div>
                        <div className="col-md h6 text-muted">
                            {data.meta?.card?.expire}
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-5 h6">
                            Gateway
                        </div>
                        <div className="col-md h6 text-muted">
                            {data.meta?.card?.gateway}
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-5 h6">
                            Country Code
                        </div>
                        <div className="col-md h6 text-muted">
                            {data.meta?.card?.countryCode}
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-5 h6">
                            Bank
                        </div>
                        <div className="col-md h6 text-muted">
                            {data.meta?.card?.bank}
                        </div>
                    </div>
                </div>    
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
                <button
                    type="button"
                    onClick={onHide}
                    className="btn btn-primary btn-elevate px-5"
                >
                    Okay
                </button>
            </Modal.Footer>
          </Modal>
}

export default DeleteSavedCard;